export default "__VITE_ASSET__03c92d1b__"